import * as React from 'react';
import UserList, {FooterTest} from './UsersList';


export default class UserManagement extends React.Component {
    public shouldComponentUpdate(nextProps: any, nextState: any, nextContext: any): boolean {
        return false;
    }

    public render() {
        return (
            <div className="main__content main__content--no-padding">
                <UserList/>
                {/*<FooterTest/>*/}
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/UserManagement/UserManagement.tsx